'use client';

import ContactForm from './ContactForm';
import useCookiePreferences from '@/hooks/useCookiePreferences';
import { Intercom, shutdown } from '@intercom/messenger-js-sdk';
import { useEffect } from 'react';

interface ContactComponentInterface {
  title?: string;
  content: string;
  isMarketingPreferences?: boolean;
}

const ContactComponent = ({ title, content, isMarketingPreferences = false }: ContactComponentInterface) => {
  const preferences = useCookiePreferences();

  if (preferences.trackingCookies) {
    Intercom({
      app_id: 'vsffcg6p',
    });
  }

  useEffect(() => {
    return () => {
      shutdown();
    };
  }, []);

  return (
    <div className="gap-large flex flex-col pt-4 lg:flex-row">
      <div className="w-full">
        {title && <h1 className="mt-0">{title}</h1>}
        <div dangerouslySetInnerHTML={{ __html: content }} />
      </div>
      <div className="w-full">
        <ContactForm isMarketingPreferences={isMarketingPreferences} />
      </div>
    </div>
  );
};

export default ContactComponent;
